import { Component, Input } from '@angular/core';
import { AgentDto, AgentProvisionFormDataDto } from '../../../../service/dto';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { HttpAgentService } from '../../../../service/http-agent.service';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { uniqueFieldValidator } from '../../../agent-provision/agent-provision.component';
import { AuthService } from '../../../../service/auth.service';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-agent-edit',
	standalone: false,
	templateUrl: './agent-edit.component.html',
	styleUrl: './agent-edit.component.scss',
})
export class AgentEditComponent {
	@Input() agent!: AgentDto;
	formGroup!: FormGroup;
	data?: AgentProvisionFormDataDto;
	saving = false;

	constructor(private authService: AuthService, private agentService: HttpAgentService, private fb: FormBuilder, private modelRef: NgbActiveModal) { }

	ngOnInit() {
		this.agentService.getProvisionData().subscribe(result => {
			this.data = result;
		});
		this.formGroup = this.fb.group({
			emailAddress: [this.agent.emailAddress ?? '', [Validators.email], [uniqueFieldValidator(this.agentService, 'email', this.agent)]],
			msisdn: [this.agent.msisdn ?? '', [Validators.pattern(/^\+?\d{9,15}$/)], [uniqueFieldValidator(this.agentService, 'msisdn', this.agent)]],
			role: [this.agent.appRole!.id,],
			authenticatorKey: [this.agent.authenticatorKey ? true : false, []]
		});

	}

	onSubmit() {
		if (this.formGroup.invalid) {
			return;
		}
		const updatedAgent = { ...this.agent };
		updatedAgent.emailAddress = this.formGroup.get('emailAddress')!.value;
		updatedAgent.msisdn = this.formGroup.get('msisdn')!.value;
		updatedAgent.appRole = this.data!.roles.filter(item => item.id == this.formGroup.get('role')!.value)[0];
		updatedAgent.authenticatorKey = this.formGroup.get('authenticatorKey')!.value == false ? undefined : this.data?.twoFactorAuthToken;

		this.saving = true;
		if (this.isSelf) {
			this.agentService.editSelf(updatedAgent)
				.pipe(finalize(() => this.saving = false))
				.subscribe(response => {
					this.modelRef.close(response);
				});
		} else {
			this.agentService.editAgent(updatedAgent)
				.pipe(finalize(() => this.saving = false))
				.subscribe(response => {
					this.modelRef.close(response);
				});
		}
	}
	get isSelf(): boolean {
		return this.agent.id == this.authService.authState?.agent.id;
	}
	getFormControl(name: string): AbstractControl {
		return this.formGroup.get(name)!;
	}
	controlInvalid(name: string): boolean {
		const ctrl = this.formGroup.get(name);
		return !!ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched);
	}

	getError(name: string): string | null {
		const ctrl = this.formGroup.get(name);
		if (!ctrl || !ctrl.errors) return null;

		if (ctrl.errors['required']) return 'This field is required';
		if (ctrl.errors['email']) return 'Invalid email format';
		if (ctrl.errors['pattern']) return 'Invalid format';
		if (ctrl.errors['notUnique']) return 'Already in use';
		if (ctrl.errors['invalidDomain']) return 'Invalid domain';
		if (ctrl.errors['InvalidMsisdn']) return 'Invalid format';
		if (ctrl.errors['invalid']) return 'Invalid';
		if (ctrl.errors['notFound']) return 'Document not found';

		return 'Invalid value';
	}

}
